<div class="wgu-container">
  <h2>Reset Password</h2>



  <div *ngIf="errorResponse && displayError" class="error-message my-3">
    <div class="error-message-left">
      <img
        alt="Error Message"
        class="img-responsive"
        src="/assets/images/landing/warning.png"
        width="56"
      />
    </div>

    <div class="error-message-middle">{{ errorResponse }}</div>

    <button (click)="closeDisplayError()" class="error-message-right">
      <img
        alt="Close Error Message"
        class="img-responsive"
        src="/assets/images/securityquestions/Close.png"
        width="16"
      />
    </button>
  </div>


  <div class="h1">Step 1: Enter Your Username</div>

  <p class="mb-6">Please provide your username so we can help you reset password:</p>

  <form
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="forgotPassword(forgotPasswordForm.value)"
    autocomplete="off"
    novalidate
  >
    <div class="form-group">
      <label class="wgu-outlined general">
        <input
          [ngClass]="{
            error:
              forgotPasswordForm.controls.username?.invalid &&
              forgotPasswordForm.controls.username?.touched,
            'error-has-value':
              forgotPasswordForm.controls.username?.invalid &&
              forgotPasswordForm.controls.username?.value
          }"
          formControlName="username"
          name="username"
          id="username"
          type="text"
          class="form-control"
          placeholder="   "
        />
        <span
          [ngClass]="{
            error:
              forgotPasswordForm.controls.username?.invalid &&
              forgotPasswordForm.controls.username?.touched
          }"
          >Username</span
        >
        <p
          *ngIf="
            f.password?.errors?.required &&
            forgotPasswordForm.controls.username?.touched
          "
          class="error-label"
        >
          Username is required
        </p>
      </label>
    </div>

    <div class="form-actions">
      <button
        class="wgu-btn"
        type="submit"
        [disabled]="forgotPasswordForm.invalid"
      >
        Next
      </button>
      <a
        href="identityiq/external/forgotPassword/cancelPage"
        class="wgu-btn-text"
      >
        Cancel
      </a>
    </div>
  </form>
</div>
